import React, { Component } from 'react'
import './style.css'
import { connect } from 'react-redux'
import Card from '../components/card/card'
import NavBar from '../components/navBar/navBar'
import { HideCard, ShowCard } from '../../src/actions'


class TipsPage extends Component {

   constructor(props) {
       super(props)
       this.state = {
       }
       document.title = 'JustLegal | Tips'
   }

    render() {
        return(
            <div className={'page ' + (this.props.cardView ? 'noscroll' : '')}>
                

                Tips page

                <NavBar language={this.props.language} page={'tips'} 
                showCard={() => this.props.dispatch(ShowCard())}/>
                
                <Card cardView={this.props.cardView} language={this.props.language} 
                hideCard={() => this.props.dispatch(HideCard())}/>
            </div>
        )
    }
}

const mapStateToProps = (state) =>({
    language: state.language,
    cardView: state.cardView,
})
export default connect(mapStateToProps)(TipsPage)


// WEBPACK FOOTER //
// ./src/ui/tipsPage/tipsPage.js